import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {FormattedMessage, useIntl} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';
import {IStore} from 'redux/interface';
import {getBackpackContent, backpackAsyncActions, getTranslations, getFavoriteNewItems} from 'redux/pageAsyncActions';

import FavoritesImg from 'assets/image/menu-auth/favorites.png';
import NotFoundImg from 'assets/image/common/notFound.png';

import CardSection from 'components/card-section';
import Loader from 'components/loader';
import NotFoundInfo from 'components/not-found-info';

import './styles.scss';

export const Backpack: React.FunctionComponent = () => {
  const {
    backpackContent, favoriteNewItems
  } = useSelector((state: IStore) => state.content);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const dispatch = useDispatch();
  const history = useNavigate();
  const intl = useIntl();
  const [isLoadCards, setIsLoadCards] = useState(true);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Backpack.toLowerCase());

    return page?.translationKey || TranslationKeys.Backpack;
  }, [settings]);

  useGetTranslations({translationKey});

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Backpack.toLowerCase());

    return page?.title || Pages.Backpack;
  }, [settings]);

  useEffect(() => {
    dispatch(backpackAsyncActions[getBackpackContent]());
    dispatch(backpackAsyncActions[getFavoriteNewItems]());
    setIsLoadCards(false);
  }, []);

  function handleOpenCard(cardId: number) {
    history(`/content#${cardId}`);
  }

  function renderFavorites() {
    return backpackContent.length === 0
      ? <>
        <NotFoundInfo
          title={intl.formatMessage({
            id: 'gritx.backpack.noFavorites',
            defaultMessage: 'No Favorites Yet'
          })}
          description={intl.formatMessage({
            id: 'gritx.backpack.noFavorites.help',
            defaultMessage: 'Tap the heart icon when you view the article to add your favorites here'
          })}
          image={NotFoundImg}
        />
      </>
      : <CardSection cards={backpackContent} onClickCard={handleOpenCard} newItems={favoriteNewItems || []}/>;
  }

  return <div className={'backpack container'}>
    {
      !loading.includes(getTranslations) && <>
        <h1 className="backpack__title"><img src={FavoritesImg} alt="" className="backpack__icon"/>
          <FormattedMessage
            id={`gritx.common.navigation.${title}`}
            defaultMessage={title}
          />
        </h1>
        <div className="backpack__cards">
          {
            loading.includes(getBackpackContent) || isLoadCards ? <Loader nested/> : renderFavorites()}
        </div>
      </>
    }

  </div>;
};
